<template>
  <BaseDialog centered contentClass="delete-dialog" ref="dialog" persistent :show-actions="true">
    <template slot="title">{{ $t('page.admin-invites.confirmation-dialog.title') }}</template>
    <template slot="content">
      <slot name="content"> </slot>
    </template>
    <template slot="actions">
      <div class="delete-dialog__actions">
        <BaseButton is-outlined class="delete-dialog__cancel" @click.native="cancelClick">{{
          $t('actions.cancel')
        }}</BaseButton>
        <BaseButton @click.native="execute" is-danger>
          <span>{{ buttonText }}</span>
        </BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';

export default {
  name: 'DeleteDialog',
  components: {
    BaseButton,
    BaseDialog,
  },
  props: {
    buttonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    openDialog() {
      this.$refs.dialog.openModal();
    },
    execute() {
      this.$emit('execute');
      this.closeDialog();
    },
    cancelClick() {
      this.closeDialog();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-dialog {
  min-height: 350px;
  max-height: 650px !important;
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
  }

  .base-dialog__actions {
    padding: 32px;
    background: transparent;
  }

  .close-icon__container {
    display: none;
  }
}

.delete-dialog {
  &__actions {
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    padding-right: 12px;
  }

  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }
}
</style>
